import { db } from '../firebase';
import { City } from '../types/city';
import { collection, addDoc, getDocs, doc, getDoc, updateDoc, deleteDoc, query, orderBy } from 'firebase/firestore';

const COLLECTION_NAME = '8am-city';

export class CityService {
  async addCity(city: City): Promise<City> {
    try {
      const docRef = await addDoc(collection(db, COLLECTION_NAME), {
        ...city,
        createdAt: new Date(),
        updatedAt: new Date()
      });
      return { id: docRef.id, ...city };
    } catch (error) {
      throw new Error('Cannot add city: ' + error);
    }
  }

  async getAllCities(): Promise<City[]> {
    try {
      const querySnapshot = await getDocs(
        query(
          collection(db, COLLECTION_NAME),
          orderBy('createdAt', 'desc')
        )
      );
      return querySnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() })) as City[];
    } catch (error) {
      throw new Error('Cannot retrieve cities: ' + error);
    }
  }

  async getCityById(id: string): Promise<City | null> {
    const docRef = doc(db, COLLECTION_NAME, id);
    const docSnap = await getDoc(docRef);
    if (docSnap.exists()) {
      return { id: docSnap.id, ...docSnap.data() } as City;
    }
    return null;
  }

  async updateCity(id: string, city: Partial<City>): Promise<void> {
    try {
      const docRef = doc(db, COLLECTION_NAME, id);
      await updateDoc(docRef, {
        ...city,
        updatedAt: new Date()
      });
    } catch (error) {
      throw new Error('Cannot update city: ' + error);
    }
  }

  async deleteCity(id: string): Promise<void> {
    try {
      const docRef = doc(db, COLLECTION_NAME, id);
      await deleteDoc(docRef);
    } catch (error) {
      throw new Error('Cannot delete city: ' + error);
    }
  }
} 